/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Empty1Inputs */

const vi_guidevideo_empty1 = /** @type {(inputs: Guidevideo_Empty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có video hướng dẫn nào.`)
};

/**

* @param {Guidevideo_Empty1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_empty1 = /** @type {((inputs?: Guidevideo_Empty1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Empty1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_empty1(inputs)
});
export { guidevideo_empty1 as "guideVideo_empty" }